exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-input[data-v-456e3648] {\n  min-height: unset;\n}\n", ""]);

// exports
